import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  CardMedia,
  IconButton,
  Divider,
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import ProfessionalEnquiryDialouge from "./ProfessionalEnquiryDialouge";

export default function ProfessionalServiceData({ image, name, description, id, serviceid, userid, brand }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [open, setOpen] = useState(false);
  
  const images = Array.isArray(image) ? image : [image];
  const totalImages = images.length;

  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prevIndex) => (prevIndex - 1 + totalImages) % totalImages);
  };

  return (
    <>
      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          borderRadius: 3,
          position: "relative",
          boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
          transition: "transform 0.3s ease",
          "&:hover": {
            transform: "translateY(-5px)"
          }
        }}
      >
        <Box sx={{ position: "relative", height: 200, overflow: "hidden" }}>
          <CardMedia
            component="img"
            height="200"
            image={images[currentIndex] || "/assets/images/placeholder_img.png"}
            alt="product"
            sx={{ objectFit: "cover", width: "100%" }}
          />

          {totalImages > 1 && (
            <>
              <IconButton
                onClick={handlePrev}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: 8,
                  transform: "translateY(-50%)",
                  bgcolor: "rgba(255,255,255,0.8)",
                  "&:hover": { bgcolor: "#fff" },
                  zIndex: 2,
                  width: 32,
                  height: 32
                }}
              >
                <ArrowBackIos sx={{ fontSize: "0.8rem", ml: 0.5 }} />
              </IconButton>
              <IconButton
                onClick={handleNext}
                sx={{
                  position: "absolute",
                  top: "50%",
                  right: 8,
                  transform: "translateY(-50%)",
                  bgcolor: "rgba(255,255,255,0.8)",
                  "&:hover": { bgcolor: "#fff" },
                  zIndex: 2,
                  width: 32,
                  height: 32
                }}
              >
                <ArrowForwardIos sx={{ fontSize: "0.8rem" }} />
              </IconButton>
            </>
          )}
        </Box>

        <CardContent
          sx={{
            flexGrow: 1,
            backgroundColor: "#FFFBF9",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "center",
            p: 2,
          }}
        >
          <Box mb={2}>
            <Typography 
              variant="subtitle1" 
              fontWeight={600} 
              sx={{ 
                maxWidth: '100%',
                wordBreak: "break-word",
                minHeight: "48px",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {name || "No Name"}
            </Typography>
            {brand && (
              <Typography variant="caption" color="text.secondary" display="block">
                Brand: {brand}
              </Typography>
            )}
            <Typography variant="body2" color="text.secondary" sx={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              height: '40px',
              mt: 0.5
            }}>
              {description || ""}
            </Typography>
          </Box>

          <Divider sx={{ width: "100%", borderColor: "#FEB821", mb: 2 }} />

          <Button
            variant="contained"
            fullWidth
            sx={{
              bgcolor: "#FEB821",
              color: "#fff",
              borderRadius: "9px",
              py: 1,
              textTransform: "capitalize",
              fontWeight: 600,
              "&:hover": { bgcolor: "#e5a71d" },
              transition: "transform 0.2s ease",
              "&:active": { transform: "translateY(0px)" }
            }}
            onClick={() => setOpen(true)}
          >
            Get Quote
          </Button>
        </CardContent>
      </Card>

      <ProfessionalEnquiryDialouge
        open={open}
        onClose={() => setOpen(false)}
        userid={userid}
        serviceid={serviceid}
        name={name}
        image={image}
        description={description}
      />
    </>
  );
}

